<template>
  <div class="login">
    <h2>Login to Fos automation app</h2>
    <form name="login-form">
      <select class="input-paper" v-model="servisCode">
        <option v-for="row in servisList"
          :key="row.servis_code"
          :value="row.servis_code"
          :selected="row.servis_code==sid">
          {{row.servis_name}}
        </option>
      </select>
    <input class="input-paper" v-model="username" placeholder="Uzivatel" />
    <input class="input-paper" v-model="password" @keyup.enter="handleLogin" 
           placeholder="Heslo" type="password" />
    <button class="button-paper" @click.prevent="handleLogin">Login</button>
  </form>
  </div>
  <div v-if="message" class="alert alert-danger" role="alert">
     {{ message }}
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

// import axios from "axios";

export default {
  setup() {
    const store = useStore()
    const router = useRouter()

    // Reactive data - convert from data() function
    const loading = ref(false)
    const message = ref(null)
    const servis = ref('')
    const username = ref('')
    const password = ref('')
    const servisCode = ref('')
    const servisList = ref([])

    // Computed properties - convert from computed object
    const loggedIn = computed(() => store.state.auth.status.loggedIn)
    // sid(){ return this.$store.state.auth.user.servis_id; }
    const sid = computed(() => '1250')

    // Methods - convert to regular functions
    const handleLogin = async () => {
        // https://www.bezkoder.com/vue-3-authentication-jwt/
        loading.value = true
        //console.log('handleLogin', this);
        const user = {
                servis:   servisCode.value,
                username: username.value,
                password: password.value
            }
        store.dispatch("auth/login", user).then(
          () => {
            router.push({name: 'dashboardMain'})
          },
          (error) => {
            console.log('handleLogin error', error)
            loading.value = false
            message.value =
              (error.response &&
               error.response.data &&
               error.response.data.message
              ) ||
               error.message ||
               error.toString()
          }
        )
    }

    // Lifecycle hooks - convert created() and mounted()
    onMounted(() => {
      //if (this.loggedIn) return this.$router.push({name: 'main'});
      // this.handleSevisList().then(x=>{this.servisList=x; console.log('x',x);});
      console.log('login created company', store.state.auth)
      console.log('login created company', store.state.auth.servisList)
      servisList.value = store.state.auth.servisList

      console.log('login mounted', store.state.login.company)
      console.log('url', router.currentRoute.value)
    })

    // Return reactive data and methods for template access
    return {
      loading,
      message,
      servis,
      username,
      password,
      servisCode,
      servisList,
      loggedIn,
      sid,
      handleLogin
    }
  }
}
</script>


<style scoped>

.login input,
.login select {
  margin: 0 10px 0;
  padding: .5rem;
}

.input-paper {
  border-bottom-left-radius: 15px 255px;
  border-bottom-right-radius: 225px 15px;
  border-top-left-radius: 255px 15px;
  border-top-right-radius: 15px 225px;
}

/* CSS */
.button-paper {
  align-self: center;
  background-color: #fff;
  background-image: none;
  background-position: 0 90%;
  background-repeat: repeat no-repeat;
  background-size: 4px 3px;
  border-radius: 15px 225px 255px 15px 15px 255px 225px 15px;
  border-style: solid;
  border-width: 2px;
  box-shadow: rgba(0, 0, 0, .2) 15px 28px 25px -18px;
  box-sizing: border-box;
  color: #41403e;
  cursor: pointer;
  display: inline-block;
  font-family: Neucha, sans-serif;
  font-size: 1rem;
  line-height: 1rem;
  outline: none;
  padding: .5rem;
  text-decoration: none;
  transition: all 150ms ease-in-out;
  border-bottom-left-radius: 15px 255px;
  border-bottom-right-radius: 225px 15px;
  border-top-left-radius: 255px 15px;
  border-top-right-radius: 15px 225px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-paper:hover {
  box-shadow: rgba(0, 0, 0, .3) 2px 8px 8px -3px;
  transform: translate3d(2px, 4px, 0);
}

.button-paper:focus {
  box-shadow: rgba(0, 0, 0, .3) 2px 8px 4px -6px;
}    
</style>
